import React from "react";
import "./Common_heading_holder.css";

function Common_heading_holder({ heading_text }) {
  return (
    <>
    <section className="Common_heading_holder">
      <div className="heading_holder">
        <div className="img_holder">
          <img src="/assets/images/heading_img/heading-up-element.png" className="heading_img" alt=" up img"/>
        </div>
        <h4 className="heading_text ">{heading_text}</h4>
        <div className="img_holder">
          <img src="/assets/images/heading_img/heading-down-element.png" className="heading_img" alt=" down img"/>
        </div>
      </div>
      </section>
    </>
  );
}

export default Common_heading_holder;
